import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dialog';
import ImageUploadForm from '@Components/ImageUploadForm';

export interface UploadAssetsDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onUploadSuccess?: () => void;
}

export default function UploadAssetsDialog({
  isOpen,
  onOpenChange,
  onUploadSuccess,
}: UploadAssetsDialogProps) {
  const handleUploadSuccess = () => {
    onOpenChange(false);
    if (onUploadSuccess) {
      onUploadSuccess();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Upload Assets</DialogTitle>
        </DialogHeader>
        <ImageUploadForm
          inputId="asset-manager-upload-input"
          accept="image-or-pdf"
          onUploadSuccess={handleUploadSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}
